export enum QRActionType {
    CheckIn = 'CHECK_IN',
    CheckOut = 'CHECK_OUT'
}